import fetchJsonp from 'fetch-jsonp';

import { getCookie } from 'tools/utils/libs/cookie';
import { isHaojieApp, is58APPVersionGreaterThan, isHaojieSDK, isGanjiApp } from 'tools/utils/index';
import { encrypt, decrypt } from 'tools/customCrypto';

import { needEntryptUrlList } from 'api/config';

import { getSearchString } from 'tools/utils/libs/helper';

import { IResponse } from './interface';
import { WxMiniConfig } from './WechartHandle';
// 引用package.json
var pjson = require('./../../package.json');

function isEncryption(url: string): boolean {
    // 开一个口子，如果访问参数里有hj_noencrypt参数则不加解密
    if (getSearchString(window.location.search, 'hj_noencrypt')) return false;
    const isProd = window.location.protocol === 'https:' && window.location.host === 'haojie.58.com';
    // const isProd = process.env.NODE_ENV !== "development"; // 上线时候要改回来，不然测试环境不太方便
    // 大于等于10.23.0的58同城时 才需要加解密 58好借需要加解密
    const isEncryptApp = isHaojieApp() || isHaojieSDK() || is58APPVersionGreaterThan('10.23.0') || isGanjiApp();
    const _url = url && url.split('?');
    return isEncryptApp && isProd && needEntryptUrlList.indexOf(_url[0]) !== -1;
}

function parseJSON(response: any) {
    return response.json();
}
const stringifyParams = (params: object) => (

    Object.keys(params).map((key: string): string => (key + '=' + encodeURIComponent(params[key]))).join('&')

);
const uuidv4 = (): string => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
};

function checkStatus(response: IResponse) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else if (response.status === 404) {
        return response;
    } else {
        // message.error('出错啦,错误代码：' + response.status);
    }

    const error: Error = new Error(response.statusText);
    error.response = response;
    throw error;
}

function handleData(data: any, isEncrypt) {
    // 如果前端不要求加密； 或者前端要求加密 但是后端直接返回了并未加密的数据 此处直接返回不解密。 并未用code判断是因为code返回0的情况 真值为false
    if (!isEncrypt || !!data.msg) {
        return data;
    }

    let decryptData = JSON.stringify({ code: 3, msg: '数据解析失败！' });
    try {
        decryptData = decrypt(data);
    } catch (e) {
        console.log(e, '数据解密失败原因');
    }
    return JSON.parse(decryptData);
}

/**
 * Requests a URL, returning a promise.
 */

let params = {};

// 开发时调试使用，因为开发时不带ppu，后端无法解析到58id
const test58ID = process.env.NODE_ENV === 'development' ? { 'actId': '52945456414477' } : {};
// 在header里加上版本号，方便定位是否有缓存
const hjVersion = pjson.version;

// 通用header，get|post使用
const commonHeader = {
    'x-app-key': WxMiniConfig.newInstance().getAppkey(),// 配置当前环境--目前用于微信小程序和微信浏览器判断
    'cache-control': 'no-cache',
    'referer-url': window.location.href,
    'Content-Type': 'application/json; charset=utf-8',
    'Accept': 'application/json',
    'Hjversion': hjVersion,
    ...test58ID,
}

export default {
    get(url: string, options?: any) {
        const isEncrypt = isEncryption(url);
        const reqId = uuidv4();
        let conn = '&';
        if (url.indexOf('?') === -1) {
            conn = '?';
        } else if (/\?$/.test(url)) {
            conn = '';
        }
        // 临时解决需要ab的业务接口请求中加headers abHeaders字段不要跟其他字段重名了
        const { abHeaders = {}, ...others } = options;
        let params = { ...others, reqid: reqId };
        url += conn + stringifyParams(params);

        return fetch(url, {
            method: 'get',
            headers: {
                'traceId': reqId,
                'x-auth-enable': isEncrypt ? 'haojie1' : '',
                ...commonHeader,
                ...abHeaders
            },
            credentials: 'include'
        })
            .then(checkStatus)
            .then(parseJSON)
            .then((data) => handleData(data, isEncrypt))
            .catch((err) => ({
                err
            }));
    },
    post(url: string, options: any) {
        const { headerParams = {}, ...others } = options;
        let body = others;
        let isEncrypt = isEncryption(url);
        if (isEncrypt) {
            try {
                body = encrypt(others);
            } catch (e) {
                console.log(e, '加密失败原因');
                isEncrypt = false; // 如果加密失败 就使用不加密方式发送数据
            }
        }
        let conn = '&';
        const reqId = uuidv4();

        if (url.indexOf('?') === -1) {
            conn = '?';
        } else if (/\?$/.test(url)) {
            conn = '';
        }
        url += `${conn}reqid=${reqId}`;
        return fetch(url, {
            method: 'post',
            headers: {
                'traceId': reqId,
                'x-csrf-token': getCookie('PPU') || '',
                'x-auth-enable': isEncrypt ? 'haojie1' : '',
                ...commonHeader,
                ...headerParams,
            },
            credentials: 'include',
            body: JSON.stringify(body)
        })
            .then(checkStatus)
            .then(parseJSON)
            .then((data) => handleData(data, isEncrypt))
            .catch((err) => ({
                err
            }));
    },
    setParams(data: object) {
        for (let k in data) {
            params[k] = data[k];
        }
    },
    clearParams() {
        params = {};
    },
    getParams(): object {
        return params;
    },
    jsonp(url: string, params: object, success?, error?) {
        let conn;

        if (url.indexOf('?') === -1) {
            conn = '?';
        } else if (/\?$/.test(url)) {
            conn = '';
        } else {
            conn = '&';
        }

        url += conn + stringifyParams(params);

        return fetchJsonp(url, {})
            .then((response) => {
                return response.json();
            }).then((json) => {
                success && success(json || {});
                return json || {};
            }).catch((ex) => {
                error && error(ex || {});
            });
    }
};
